import { Component } from '@angular/core';
import { Router } from "@angular/router"
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, AtributosService, MenuService } from '../_services';
import { ActivatedRoute } from '@angular/router';
import { MyFunctions } from '@app/_helpers';
import { SelectableSettings } from '@progress/kendo-angular-treelist';

@Component({
  selector: 'app-atributos',
  templateUrl: './atributos.component.html',
})

export class AtributosComponent {

  //VARIABLES BASICAS
  private translate: TranslateService;

  public settings: SelectableSettings = {
    mode: "row",
    multiple: true,
    drag: false,
    enabled: true,
    readonly: false
  };

  //GRID: atributos
  public listaatributos: any[] = [];
  public dataGrid: any;

  //Seleccion
  public seleccionados: any[] = [];

  //Constructor
  constructor(
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private alertService: AlertService,
    public route: ActivatedRoute,
    private atributosService: AtributosService,
    public myFunctions: MyFunctions) {

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('atributos').toUpperCase();
  }

  /**
   * Funcion de ngOnInit, carga las atributos de la DB
   */
  ngOnInit() {
    this.atributosService.getAtributos().subscribe(
      (result) => {
        this.dataGrid = result;
      });
  }

  /**
   * Al clicar en el boton Editar, gestiona errores y 
   * navega a atributos/editar
   */
  onClick_Editar(event) {
    // if (this.seleccionados.length > 1) {
    //   this.alertService.error(this.translateService.instant('multiplesatributos'), { keepAfterRouteChange: true });
    // } else if (this.seleccionados.length == 0) {
    //   this.alertService.warn(this.translateService.instant('atributosnoseleccionada'), { keepAfterRouteChange: true });
    // } else {
      this.router.navigate(['atributos/editar/', event.dataItem.id]);
    // }
  }

  onClick_Nuevo() {
    this.router.navigate(['atributos/editar/0']);
  }

  /**
   * Al clicar el boton Eliminar, muestra el modal
   * de confirmacion de eliminar
   * @param eliminar modal de eliminar
   */
  onClick_Elimnar(eliminar) {
    if (this.seleccionados.length == 0) {
      this.alertService.warn(this.translateService.instant('atributosnoseleccionada'), { keepAfterRouteChange: true });
    } else {
      this.modalService.open(eliminar, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  /**
   * Se llama al confirmar eliminacion de las atributos seleccionadas 
   * en el modal de eliminar. Elimina las atributos y obtiene las atributos
   * actualizadas refrescando la fuente de datos del grid
   */
  eliminaratributos() {
    var selected = []
    this.seleccionados.forEach(element => {
      selected.push(element.itemKey)
    })
    this.atributosService.removeAtributo(selected).subscribe(
      (result) => {
        console.log("atributos eliminadas");
        this.modalService.dismissAll();
        this.alertService.success(this.translateService.instant('atributoeliminado'), { keepAfterRouteChange: true });
        this.listaatributos = [];
        this.atributosService.getAtributos().subscribe(
          (result) => {
            this.dataGrid = result;
          });
      });
  }
}
